import { EnrollmentStateTypes } from '@/entities';
import type { IEnrollmentData } from '@/entities';

import { translateMetadata } from '@/utils';
import type { EnrollmentStateType, IEnrollmentResponse } from '@/services/prime/enrollment';
import { guards, type IncludedType } from '@/services';
import { mapPrimeInstance } from '@/mappers/instance';

export const mapPrimeEnrollment = (data: IEnrollmentResponse, included?: IncludedType[]): IEnrollmentData => {
  const learningObject = included
    ?.filter(guards.isLearningObject)
    .find((lo) => lo.id === data.relationships?.learningObject?.data.id);
  const learningObjectInstance = included
    ?.filter(guards.isInstance)
    .find((i) => i.id === data.relationships?.loInstance?.data.id);

  return {
    id: data?.id,
    uniqueId: learningObject?.attributes.uniqueId,
    enrollmentSource: data.attributes.enrollmentSource,
    progressPercent: data.attributes.progressPercent,
    score: data.attributes.score,
    hasPassed: data.attributes.hasPassed,
    completionDeadline: data.attributes.completionDeadline || '',
    dateEnrolled: data.attributes.dateEnrolled || '',
    dateCompleted: data.attributes.dateCompleted || '',
    state: toEnrollmentStateTypes(data.attributes.state),
    name: translateMetadata(learningObject?.attributes?.localizedMetadata)?.name || '',
    instance: learningObjectInstance ? mapPrimeInstance(learningObjectInstance, included) : undefined,
    learningObjectId: data.relationships?.learningObject?.data.id
  };
};

const toEnrollmentStateTypes = (state: EnrollmentStateType): EnrollmentStateTypes => {
  if (state == 'COMPLETED') return EnrollmentStateTypes.Completed;
  if (state == 'STARTED') return EnrollmentStateTypes.Started;
  if (state == 'APPROVED') return EnrollmentStateTypes.Approved;
  if (state == 'PENDING_APPROVAL') return EnrollmentStateTypes.Pending;
  return EnrollmentStateTypes.Enrolled;
};
